import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

/**
 * True when viewport is below the given breakpoint (default md / 900px).
 * Use for switching table views to card lists on phones and compact layouts.
 *
 * @param {'xs'|'sm'|'md'|'lg'|'xl'} breakpoint
 */
export default function useIsMobileList(breakpoint = "md") {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(breakpoint));
}
